// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"25f6407a","424":"cd9bd7c0","595":"e6d0739d","999":"39b7f9ae"}[chunkId] + ".chunk.css";
};